interface BadgeProps {
  status: string;
  children: React.ReactNode;
}

const Badge = ({ status, children }: BadgeProps) => {
  const base = "px-3.5 py-1.5 text-[11px] font-semibold rounded-full border whitespace-nowrap tracking-wide";

  const colors: Record<string, string> = {
    "Won Lead": "bg-emerald-100 text-emerald-700 border-emerald-200",
    "Lost Lead": "bg-red-100 text-red-700 border-red-200",
    "Negotiated": "bg-amber-100 text-amber-700 border-amber-200",
    "Pending": "bg-gray-100 text-gray-700 border-gray-200",
    "Need to Contact": "bg-[#2462b2]/10 text-[#2462b2] border-[#2462b2]/20",
    "Contacted - No Response": "bg-orange-100 text-orange-700 border-orange-200",
    "Contact in Future": "bg-purple-100 text-purple-700 border-purple-200",
  };

  return (
    <span className={`${base} ${colors[status] || "bg-gray-100 text-gray-700 border-gray-200"}`}>
      {children}
    </span>
  );
};

export default Badge;
